/**
 * The phone install offer's words (InstallAppBanner.tsx): the band's offer, its phone lines, the success line and the
 * add-to-home-screen guide. In a module of their own (the banner band, PV5-8:D part 2) so today's offer and the new
 * design's band and guide read one table: the new design may not import InstallAppBanner.tsx, which brings
 * styled-components (E0d).
 */
export const INSTALL_COPY = {
  android: 'prest0 works best as an app on your phone — one tap to install it.',
  androidCta: 'install app',
  ios: 'prest0 works best as an app on your phone — a few taps from the share menu, we’ll show you.',
  iosCta: 'add to home screen',
  success: 'you’re set — open prest0 from your home screen next time.',
  /* The phone lines (2026-09-13). This source is the one that ONLY ever shows
     on a phone, so its full copy was already written for a narrow screen —
     these drop the sales clause ("works best as an app") and keep the action,
     which is all a reader who has already decided needs to see. */
  androidShort: 'install prest0 on your phone — one tap.',
  iosShort: 'add prest0 to your home screen.',
  iosShortCta: 'show me',
  successShort: 'you’re set — open prest0 from your home screen.',
  sheetTitle: 'add prest0 to your home screen',
  sheetStepShare: 'tap the share button in your browser’s toolbar',
  sheetStepAdd: 'scroll and tap “add to home screen”',
  sheetStepConfirm: 'tap “add” in the top corner — that’s it',
  sheetClose: 'got it',
} as const;
